module.exports = __webpack_public_path__ + "static/media/bensound-evolution.af350416.mp3";